<template>
    <DefaultTemplate :model="model">
        <div class="container">
            <div class="mt-12 mb-8">
                <Breadcrumbs :breadcrumbs="model.breadcrumbs" className="text-grey-400" />
            </div>

            <div class="block lg:flex">
                <div class="w-full lg:w-3/4 pr-0 lg:pr-4">
                    <article class="p-4 md:px-10 md:py-4 lg:px-20 lg:py-10 mb-4 bg-white">
                        <h1 v-epi-edit="'Name'" class="mb-2 font-semibold">
                            {{ model.name }}
                        </h1>
                        <hr class="my-4 lg:my-4"/>
                        <div v-epi-edit="'Answer'" id="main-body" class="main-body my-4 article pt-4" v-html="this.model.answer" />
                    </article>
                </div>
            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
import Breadcrumbs from '@/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue';


export default {
    props: ['model'],
    components: {
        Breadcrumbs
    }
};
</script>
